import styled from '@emotion/styled';

interface Props {
    isActive?: boolean;
}

function Dot({ isActive }:Props) {
    return (
        <Container isActive={isActive}>
            <Background />
            <Circle />
        </Container>
    );
}

const Container = styled.div<{ isActive?: boolean }>`
    align-items: center;
    background-color: var(--color-white);
    border-radius: 12px;
    display: flex;
    height: 24px;
    justify-content: center;
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    overflow: hidden;
    position: relative;
    width: 24px;
`;

const Background = styled.div`
    background-color: var(--color-primary);
    height: 100%;
    left: 0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    width: 100%;
`;

const Circle = styled.div`
    background-color: var(--color-white);
    border-radius: 8px;
    height: 16px;
    position: relative;
    width: 16px;
`;

export default Dot;
